import strings from 'strings';

export const buildCloseAndSaveButtonDefinition = ({
  onClose,
  isSaveDisabled,
  isSaving,
  gridColumnValue = 'auto'
}) => {
  return [
    {
      props: {
        text: strings.shared.ui.close,
        variant: 'outlined',
        onClick: onClose
      },
      GridItemProps: {
        md: gridColumnValue
      }
    },
    {
      props: {
        initialText: strings.shared.ui.save,
        variant: 'contained',
        type: 'submit',
        disabled: isSaveDisabled,
        onProgressText: strings.shared.ui.saving,
        isSaving
      },
      GridItemProps: {
        md: gridColumnValue
      },
      mode: 'save'
    }
  ];
};

export const buildCloseAndGoBackDefinition = ({ onClose, onGoBack }) => [
  {
    props: {
      text: strings.shared.ui.close,
      variant: 'outlined',
      onClick: onClose
    },
    GridItemProps: {
      md: 3
    }
  },
  {
    props: {
      text: strings.shared.ui.goBack,
      variant: 'contained',
      onClick: onGoBack
    }
  }
];
